export const AUTOMATIC_RESTOCKING_TYPES = [
  { type: "by_date", name: "Fecha" },
  { type: "by_stock", name: "Inventario" },
]
